<template>
  <el-dropdown
    v-if="renderWidthNoData || dropdownItems.length > 0"
    @command="handleCommand"
  >
    <span :class="className">
      {{ label }}<i class="el-icon-arrow-down el-icon--right" />
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in dropdownItems"
        :key="item.name"
        :command="item.name"
        :disabled="isDisableItem(item) === 'visible'"
        >{{ item.label }}</el-dropdown-item
      >
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
export default {
  name: "MyDropdown",
  props: {
    label: {
      type: String,
      default: "更多",
    },
    className: {
      type: String,
      default: "el-dropdown-link",
    },
    renderWidthNoData: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    onSelected: {
      type: Function,
      default: () => {},
    },
    row: {},
  },
  computed: {
    // 获取操作列中需要折叠起来的项
    dropdownItems() {
      return this.items;
    },
  },
  created() {},
  methods: {
    isDisableItem(optItem) {
      if (!optItem.disable) {
        return false;
      }
      return optItem.disable(this.row);
    },
    handleCommand(key) {
      const curItem = this.dropdownItems.find((item) => item.name === key);
      this.onSelected(curItem);
    },
  },
};
</script>

<style lang="scss">
.el-dropdown-link {
  cursor: pointer;
  padding: 2px 5px;
  margin: 0 5px;

  &:hover {
    color: #000;
  }
}
ul.my-dropdown-content {
  position: absolute;
  right: 0;
  min-width: 180px;
  border: 1px solid;
  background: #ddd;
  z-index: 2;
  list-style: none;
  padding: 10px 0;
  line-height: 30px;

  > li {
    padding: 5px 10px;
  }
  > li.hover {
    background: #ccc;
  }
}
</style>
